import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { PreparationAdditionalInformationDialog } from "@/modules/patients/detail/medication/de/preparation-additional-information-dialog"
import { useDePreparationAdditionalInformationQuery } from "@/modules/patients/detail/medication/de/services/useDePreparationAdditionalInformationQuery"

type PreparationAdditionalInformationProps = {
  pharmaceuticalCentralNumber: string
}

export const PreparationAdditionalInformation = (props: PreparationAdditionalInformationProps) => {
  const { t } = useTranslation()
  const [openMedicationDialog, setOpenMedicationDialog] = useState(false)

  const { specialistInformation, letterInformation } = useDePreparationAdditionalInformationQuery(
    props.pharmaceuticalCentralNumber,
  )

  return (
    <div>
      <Button
        variant="tertiary"
        className="h-auto w-fit p-0 font-normal underline hover:bg-transparent focus-visible:bg-transparent active:bg-transparent"
        onClick={() => setOpenMedicationDialog(true)}
        data-testid="preparation-more-information-button">
        {t("patient.medication.moreInformation")}
      </Button>
      {openMedicationDialog && (
        <PreparationAdditionalInformationDialog
          onOpenChange={setOpenMedicationDialog}
          specialistInformation={specialistInformation}
          letterInformation={letterInformation}
        />
      )}
    </div>
  )
}
